"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _EV33XSIBcjs = require('../__chunks/EV33XSIB.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/combobox/combobox-value.tsx
var _misc = require('@ariakit/core/utils/misc');
function ComboboxValue({ store, children } = {}) {
  const context = _EV33XSIBcjs.useComboboxContext.call(void 0, );
  store = store || context;
  _misc.invariant.call(void 0, 
    store,
    process.env.NODE_ENV !== "production" && "ComboboxValue must receive a `store` prop or be wrapped in a ComboboxProvider component."
  );
  const value = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "value");
  if (children) {
    return children(value);
  }
  return value;
}


exports.ComboboxValue = ComboboxValue;
